export const OFERTA_LINK = '/oferta';
export const AYUDA_LINK = '/ayuda';
export const PERFIL_LINK = '/perfil';
export const SALIR_LINK = '/salir';